import React, { ReactNode, createContext, useContext, useState } from "react";

interface NodeDiagramContextProps {
	oldDiagram: boolean;
	edit: boolean;
	updateState: (oldDiagram: boolean) => void;
	setEdit: (edit: boolean) => void;
}

const NodeDiagramContext = createContext<NodeDiagramContextProps | undefined>(
	undefined,
);

export const NodeDiagramProvider: React.FC<{ children: ReactNode }> = ({
	children,
}) => {
	const [oldDiagram, setOldDiagram] = useState<boolean>(false);
	const [edit, setEdit] = useState<boolean>(false);

	const updateState = (newState: boolean) => {
		setEdit(false);
		setOldDiagram(newState);
	};

	return (
		<NodeDiagramContext.Provider
			value={{ oldDiagram, edit, updateState, setEdit }}
		>
			{children}
		</NodeDiagramContext.Provider>
	);
};

export const useNodeDiagramContext = () => {
	const context = useContext(NodeDiagramContext);
	if (context === undefined) {
		throw new Error(
			"useNodeDiagramContext must be used within a NodeDiagramProvider",
		);
	}
	return context;
};
